import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { CompanyEndpointMethod } from '../../../../quarantine/exchangeProtection/types';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';

export class CompaniesForEasmDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getItems({ searchValue, page, limit }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          page,
          limit,
          companyName: searchValue,
          options: {
            source: 'fromEASM',
          },
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          limit: DEFAULT_DATA_LIMIT,
          options: {
            source: 'fromEASM',
          },
        },
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
